import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL;

export default {
    createContactPerson(data, customerId, token) {
        var contactPersonsUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/contacts';
        return Axios.post(`${contactPersonsUrl}`, data);
    },
    getAll(customerId, token) {
        var contactPerosnsUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/contacts';
        return Axios.get(`${contactPerosnsUrl}`);
    },
    deleteContactPerson(customerId, contactPersonId){
        var contactPerosnsUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/contacts/' + contactPersonId;
        return Axios.delete(`${contactPerosnsUrl}`);
    },
    updateContactPerson(data, contactPersonId, customerId, token) {
        var contactPerosnsUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/contacts/' + contactPersonId;
        return Axios.put(`${contactPerosnsUrl}`, data);
    },
    changePassword(customerId, contactPersonId, data, token){
        var passwordUrl =  RESOURCE_NAME +  'customers/' + customerId + '/contacts/' + contactPersonId + '/change-password';
        return Axios.post(`${passwordUrl}`, data);
    },
    /**
     * Switch Contact Person To Primary
     */
    switchContactPersonToPrimary(data, token) {
        return Axios.post(`${RESOURCE_NAME}customers/switch-contact-person-to-primary`, data);
    }
};
